//
//
//
//

import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm._v("CbTeamRank")]);
};
var staticRenderFns = [];
export default defineComponent({
  render,
  name: 'CbTeamRank'
});